// import axios from 'axios'
import unirest from 'unirest'
const clientes = {}
const token = localStorage.getItem('repov4-token')

const API_TEMA = process.env.VUE_APP_TEMA_API
clientes.find = (params) =>
	unirest.get(API_TEMA + '/clientes')
		.headers({ 'Content-Type': 'application/json', 'temas-token': token })
		.qs({ skip: params.skip })

clientes.findById = id =>
	unirest.get(API_TEMA + `/clientes/${id}`)
		.headers({ 'Content-Type': 'application/json', 'temas-token': token })

clientes.findByActive = () =>
	unirest.get(API_TEMA + '/clientes/ativos')
		.headers({ 'Content-Type': 'application/json', 'temas-token': token })

clientes.create = data =>
	unirest.post(API_TEMA + '/clientes')
		.headers({ 'Content-Type': 'application/json', 'temas-token': token })
		.send(data)

clientes.update = (id, data) =>
	unirest.put(API_TEMA + `/clientes/${id}`)
		.headers({ 'Content-Type': 'application/json', 'temas-token': token })
		.send(data)

clientes.delete = id =>
	unirest.delete(API_TEMA + `/clientes/${id}`)
		.headers({ 'Content-Type': 'application/json', 'temas-token': token })

export { clientes }
